import { Modal } from 'components/Modal';
import styles from './ModaCanBeRemote.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';

export const ModaCanBeRemote = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (e: boolean) => void;
}) => {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Внимание' />
        <p className={styles.root_message}>
          Для данной услуги невозможно назначить удаленный тип работы. Укажите адрес или
          выберите другую услугу.
        </p>
        <div className={styles.root_btn}>
          <Button
            onClick={() => setOpen(false)}
            className={styles.root_btn_exit}
            theme='filed'
            size='L'>
            <div>Закрыть</div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
